import {
  HTTP_GETBUDGETCOMPDBYBRAND_FETCHING,
  HTTP_GETBUDGETCOMPDBYBRAND_SUCCESS,
  HTTP_GETBUDGETCOMPDBYBRAND_FAILED,
  server,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const setStateBudgetCompDBToFetching = () => ({
  type: HTTP_GETBUDGETCOMPDBYBRAND_FETCHING,
});

export const setStateBudgetCompDBToSuccess = (payload) => ({
  type: HTTP_GETBUDGETCOMPDBYBRAND_SUCCESS,
  payload,
});

export const setStateBudgetCompDBToFailed = (payload) => ({
  type: HTTP_GETBUDGETCOMPDBYBRAND_FAILED,
});

export const clearBudgetCompDB = () => {
  return async (dispatch) => {
    dispatch(setStateBudgetCompDBToSuccess([]));
  };
};

export const getBudgetCompDB = (country, company, year,secid, item) => {
  return async (dispatch) => {
    dispatch(setStateBudgetCompDBToFetching());
    try {
      const result = await httpClient.put(
        `${server.GETBUDGETCOMPBYBRANDD_URL}/${country}/${company}/${year}/${secid}`,
        item,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(setStateBudgetCompDBToSuccess(result.data));
      return Promise.resolve(result.data[0]);
    } catch (error) {
      dispatch(setStateBudgetCompDBToFailed());
    }
  };
};
